module.exports = __webpack_public_path__ + "assets/img/immediatelyEnroll.9ad25977.png";